<template>
  <!--begin::Modal - View Users-->
  <div
    class="modal fade"
    id="kt_modal_view_users"
    tabindex="-1"
    aria-hidden="true"
    ref="searchTransferBookProductModalRef"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-850px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <loading
          v-model:active="isLoading"
          :can-cancel="true"
          :is-full-page="false"
        />
        <!--begin::Modal header-->
        <div class="modal-header pb-0 border-0 justify-content-between">
          <!--begin::Close-->

          <h1 class="mb-3">เลือกสินค้า</h1>
          <div
            class="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--begin::Modal header-->

        <!--begin::Modal body-->
        <div class="modal-body pb-0">
          <!--begin::Heading-->

          <!--end::Heading-->
          <!-- <form data-kt-search-element="form" class="w-100 position-relative mb-5" autocomplete="off"> -->
          <div class="row">
            <div class="col-8">
              <el-input
                placeholder="Type something"
                prefix-icon="bi bi-search fs-4 ps-1 "
                v-model="searchText"
                clearable
              >
              </el-input>
            </div>
            <div class="offset-1 col-2 d-flex align-items-center">
              <span class="fs-5 me-3"> แสดง </span>
              <el-checkbox v-model="readyForSale" label="สต๊อก > 0" size="large" />
            </div>
          </div>
          <!-- </form> -->
          <!--begin::Users-->
          <div class="mt-3">
            <!--begin::List-->
            <div class="mh-375px me-n7 pe-7">
              
              <el-table
                :data="showProduct"
                stripe
                ref="tbProductSelect"
                @selection-change="handleProductSelectionChange"
                style="width: 100%"
                height="375px"
              >
                <el-table-column type="index" prop="productID" :disabled=true width="40">
                  <template #default="scope">
                    <div class="d-flex align-items-center">
                    <input type="checkbox"
                      :checked="selected.includes(scope.row.productID)" 
                      @change="() => onSelectProductCheckboxChangeHandler(scope.row.productID)"/>
                      </div>
                  </template>
                </el-table-column>
                <el-table-column sortable prop="productName" label="สินค้า">
                </el-table-column>
                <el-table-column
                  sortable
                  prop="stockQuantity"
                  label="จำนวนสต๊อก"
                  align="right"
                  width="130"
                >
                  <template #default="scope">  
                    {{ numberWithCommas(scope.row.stockQuantity, 0) }}
                  </template>
                </el-table-column>
                <el-table-column
                  sortable
                  prop="stockQuantity2S"
                  label="สต็อก 2S"
                  align="right"
                  width="150"
                >
                  <template #default="scope">  
                    <div v-if="scope.row.stockQuantity2S > 0">                
                      <div v-if="scope.row.planFinDate != null && scope.row.planFinDate != '0001-01-01T00:00:00'">
                        <el-tooltip
                        class="item"
                        effect="dark"
                        :content="getPlanFinDate(scope.row)"
                        placement="top"
                        :disabled="!scope.row.productIsSteel"
                        >              
                        <span style="cursor: pointer;">{{ numberWithCommas(scope.row.stockQuantity2S, 0) }} <i class="fas fa-calendar-day"></i></span>
                        </el-tooltip>                     
                      </div>
                      <div v-else>{{ numberWithCommas(scope.row.stockQuantity2S, 0) }}</div>                
                    </div>
                    <div v-else>
                      <div v-if="scope.row.planFinDate != null && scope.row.planFinDate != '0001-01-01T00:00:00'">
                        <el-tooltip
                        class="item"
                        effect="dark"
                        :content="getPlanFinDate(scope.row)"
                        placement="top"
                        :disabled="!scope.row.productIsSteel"
                        >              
                        <span style="cursor: pointer;">0 <i class="fas fa-calendar-day"></i></span>
                        </el-tooltip>                     
                      </div>
                      <div v-else>0</div>
                    </div>
                  </template>
                </el-table-column>                
                <el-table-column
                  sortable
                  prop="productWeight"
                  label="น้ำหนัก"
                  align="right"
                  width="120"
                >
                  <template #default="scope">  
                    {{ numberWithCommas(scope.row.productWeight, 2) }}
                  </template>                
                </el-table-column>
              </el-table>
            </div>
            <!--end::List-->
          </div>
          <!--end::Users-->
        </div>
        <!--end::Modal body-->
        <div class="modal-footer border-0">
          <button type="button" class="btn btn-secondary" @click="hide">
            กลับ
          </button>
          <button type="button" class="btn btn-primary ms-5" @click="submit">
            ยืนยัน
          </button>
        </div>
      </div>
      <!--end::Modal content-->
    </div>
    <!--end::Modal dialog-->
  </div>
  <!--end::Modal - View Users-->
</template>

<script>
import { Modal } from "bootstrap";
import ApiService from "@/core/services/ApiService";
import { numberWithCommas, formatDateFromISO } from "@/utils";
import Loading from "vue-loading-overlay";

export default {
  components: { Loading },
  props: {
    modelValue: Array,
  },
  data() {
    return {
      products: [],
      modal: null,
      searchText: null,
      selected: [],
      isLoading: false,
      readyForSale: true
    };
  },
  mounted() {
    this.modal = new Modal(this.$refs.searchTransferBookProductModalRef);
  },
  watch: {
    readyForSale() {
      this.getProducts();
    },
  },
  computed: {
    showProduct() {
      const regex = new RegExp(this.searchText ? this.searchText :  "", "gi");
      return this.products.filter((product) => product.productName.match(regex));
    },
  },
  methods: {
    show() {
      this.modal.show();
      this.selected = [];
      this.getProducts();
    },
    hide() {
      this.modal.hide();
    },
    getProducts: async function () {
      try {
        this.isLoading = true;
        const { data } = await ApiService.query("transferstore/TransferBookStockGet", {
          params: { StockOverZero: this.readyForSale },
        });
        this.products = data;
        // console.log(this.products);
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    checkNonSelectedProduct(product) {
      return (
        !this.modelValue ||
        !this.modelValue.find((p) => p.productID == product.productID)
      );
    },
    handleProductSelectionChange(val) {
      this.selected = val;
    },
    onSelectProductCheckboxChangeHandler(val) {
      if(this.selected.find(v => v == val))
      {
        this.selected = this.selected.filter(v => v != val)
      } else  {
        this.selected.push(val)
      }
    },
    getPlanFinDate(product){
      return "แผนผลิต: " + formatDateFromISO(product.planFinDate);
    },    
    submit() {
      // console.log(this.modelValue);
      let result = this.modelValue || [];
      this.products.filter( p => this.selected.includes(p.productID)).forEach((product) => {
        if (this.checkNonSelectedProduct(product)) {
          result.push({
            ...product,
            quantity: (product.productSellBundle || product.priceSplitBundle > 0 ? product.priceQuanPerPack : 1),
            price: product.priceStandard,
            quanBundle: (product.productSellBundle || product.priceSplitBundle > 0 ? 1 : 0),
            quanPiece: 0,
          });
        }
      });
      this.$emit("update:modelValue", result);
      this.hide();
    },    
    numberWithCommas,
    formatDateFromISO
  },
};
</script>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
